// extracted by mini-css-extract-plugin
module.exports = {"error_badge":"ErrorBadge_error_badge__zZl2d"};